<template>
  <div class="content">
    <div class="title">用户隐私协议</div>
    公司名称：杭州韵玟科技有限公司
    <br />
    更新日期：2024年12月11日
    <br />
    生效日期：2024年12月11日
    <br />
     
    本隐私协议是由用户（以下简称为"您"）与杭州韵玟科技有限公司及其关联公司及第三方合作公司（以下简称为"我们"）就我们所提供的游戏产品及服务所订立的协议。有关个人信息保护的联系方式为：邮箱：youxi@yunwente.cn
    <br />
    您在使用我们提供的产品及服务前需仔细阅读《用户隐私协议》（以下简称“本协议”），详细了解我们对信息的收集、使用、存储和共享个人信息的情况以及您所享有的相关权利等事宜，其中要点如下：
    <br />
    ✱为了向您提供游戏娱乐以及与此相关的玩家互动、消费等服务，我们需要收集您的游戏历史、设备信息、登录日志等信息。
    <br />
    ✱为更好地保护未成年人身心健康，促使未成年人健康上网，我们可能在国家有关网络游戏防沉迷政策规定的基础上，实施更为严格的防沉迷措施。同时我们也不断研究与测试各种保护未成年人的新技术。
    <br />
    ✱您可以根据本指引所述管理您的个人信息以及相关授权。
    <br />
    ✱我们采用多方位的安全保护措施，以确保对您的个人信息保护处于合理的安全水平。
    <br />
    ✱本隐私协议仅代表您已了解应用提供的功能，以及功能运行所需的必要个人信息，并不代表您已同意我们可以收集非必要个人信息，非必要个人信息会根据您使用过程中的授权情况单独征求您的同意。
    <br />
    ✱相应设备权限并不会默认开启，当涉及重要或敏感的设备权限时，我们会在您使用到相应业务功能时，另行弹窗再次征得您的同意后开启；权限开启后，您还可以随时通过设备设置关闭权限；你不同意开启权限，将不会影响其他非相关业务功能的正常使用。针对个人敏感信息，我们会单独征得您的同意后进行处理。
    <br />
    第一章 我们收集的信息
    <br />
    在您使用游戏服务的过程中，我们会根据合法、正当、最小必要原则，收集实现产品功能所需的信息。我们会按照如下方式收集您在使用服务时主动提供的或因为使用服务而产生的信息，用以向您提供、优化我们的服务以及保障您的账户安全：
    <br />
    1.1 当您注册或使用我们所提供的游戏产品及服务时，我们会收集您的网络身份标识信息及个人常用设备信息，用于标记您为我们游戏的用户。如果您使用我们认可的其他账号（以下称“第三方账号”）作为游戏账号关联登录游戏的，我们会收集您第三方账号的唯一标识、头像、昵称，用于保存您的登录信息，以便您在不同设备登录。
    <br />
    1.2 为满足相关法律法规政策及相关主管部门的要求，游戏用户需进行实名认证以继续使用和享受游戏。我们会在获得您同意或您主动提供的情况下收集您的实名身份信息（包括姓名、身份证号等信息），该信息属于敏感信息，拒绝提供实名身份信息可能会导致您无法登录游戏或在使用游戏过程中受到相应限制。
    <br />
    1.3 为保障您正常使用我们的服务，维护游戏基础功能的正常运行，优化游戏产品性能，提升您的游戏体验并保障您的账号安全，我们会收集您的个人常用设备信息（包括设备ID、设备名称、设备类型和版本、设备品牌、运营商、软件列表、系统版本、MAC地址、IP地址、设备识别符（如 IMEI/IMSI/GUID/Android ID/OAID/IDFA/OPENUDID等）等在内的描述个人常用设备基本情况的信息）、应用ID、网络类型等信息。
    <br />
    1.4 当您使用游戏服务时，我们会收集您的游戏日志信息，例如登录日志、物品日志、游戏信息、交友记录等，以便您能够在客户端查看您的游戏历史记录，同时用于游戏运营统计分析、客服投诉处理及其他游戏安全分析，并为提升您的游戏体验，我们可能把前述信息同步至该游戏后续版本或您正在使用的我们提供的其他产品中。
    <br />
    1.5 当您使用游戏产品的消费功能时，我们会收集您的充值记录、消费记录等信息，以便您查询您的交易记录，同时尽最大程度保护您的虚拟物品安全。充值记录、消费记录属于敏感信息，收集上述信息为实现游戏产品的消费功能所必须，否则将无法完成交易。
    <br />
    1.6 为保障您的游戏账号安全，营造公平、健康及安全的游戏环境，我们会收集您的游戏识别信息、硬件及操作系统信息、进程及游戏崩溃记录等信息，以用于打击破坏游戏公平环境或干扰、破坏游戏服务正常进行的行为（如用于检测盗版、扫描外挂、防止作弊等）。
    <br />
    1.7 当您在游戏中通过文字、图片及其他方式与其他玩家进行互动，我们可能会收集并保存您发送的上述信息内容用于过滤色情、暴力、政治、辱骂、恶意广告等不当内容，以此净化游戏环境，维护健康的上网环境。
    <br />
    1.8 为保障游戏安全稳定运行并实现特定功能，部分游戏可能会接入第三方开发的软件工具开发包（Software Development Kit，SDK）。我们会对游戏接入的涉及个人信息收集的SDK进行安全监测，以保护您的个人信息安全。具体情况请见附件《第三方信息共享清单》。
    <br />
    1.9 在您使用该业务功能时，我们的App会向您申请下列与个人信息相关的系统权限：
    <br />
    如果您不授权，将会导致我们无法提供该业务功能。除上述权限之外，您可自主选择是否额外授予App其他的系统权限。
    <br />
    设备权限和使用目的及场景：
    <br />
    获取联网功能：用于请求服务器数据，使用户能正常安装游戏、进行游戏等；
    <br />
    获取网络状态: 用于下载游戏时告知用户是否使用流量网络等；
    <br />
    允许应用程序读取设备外部存储空间的文件：Android28以下设备仅通过该权限才能将更新的下载内容存到本地；
    <br />
    允许程序写入外部存储：Android28以下设备仅通过该权限才能将更新的下载内容存到本地；
    <br />
    获取手机设备信息：以便更好地解决用户问题，提升游戏体验等；
    <br />
    安装权限：包体更新时需要通过该权限安装，以便用户能及时体验到最新版本内容，提升游戏体验等；
    <br />
    获取录音功能：用于用户语音聊天等；
    <br />
    获取麦克风权限: 用户可以通过调取麦克风进行语音等；
    <br />
    如您发现我们违反法律、行政法规的规定或者双方的约定收集、使用您的个人信息，您可以要求我们删除。如您发现我们收集、存储的您的个人信息有错误的，您也可以要求我们更正。
    <br />
    请通过本隐私协议列明的联系方式与我们联系。
    <br />
    在您访问、修改和删除相关信息时，我们可能会要求您进行身份验证，以保障帐号的安全。
    <br />
    1.11 根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：
    <br />
    1）与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公共知情等重大公共利益直接相关的；
    <br />
    2）与犯罪侦查、起诉、审判和判决执行等直接相关的；
    <br />
    3）出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；
    <br />
    4）所收集的个人信息是您自行向社会公众公开的；
    <br />
    5）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
    <br />
    6）根据您要求签订和履行合同所必需的；
    <br />
    7）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
    <br />
    8）为开展合法的新闻报道所必需的；
    <br />
    9）出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
    <br />
    10）法律法规规定的其他情形。
    <br />
    1.11 请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。
    <br />
    我们不会主动从第三方获取您的个人信息。如未来为业务发展需要从第三方间接获取并处理您的个人信息的，我们会严格遵守相关法律法规的规定，要求该第三方征得您的同意并确保其提供的信息的合法性。
    <br />
      第二章 信息的存储
    <br />
    2.1信息存储的方式和期限
    <br />
    我们会通过安全的方式存储您的信息，包括本地存储（例如利用APP进行数据缓存）、数据库和服务器日志。
    <br />
    一般情况下，我们只会在为实现服务目的所必需的时间内或法律法规规定的条件下存储您的个人信息。
    <br />
    2.2 信息存储的地域
    <br />
    我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。
    <br />
    2.3 产品或服务停止运营时的通知
    <br />
    当我们的产品或服务发生停止运营的情况时，我们将根据相关法律法规规定进行公告通知，并依法保障您的合法权益。
    <br />
      第三章 信息安全
    <br />
    3.1 安全保护措施
    <br />
    我们努力为用户的信息安全提供保障，以防止信息的泄露、丢失、不当使用、未经授权访问和披露等。我们使用多方位的安全保护措施，以确保用户的个人信息保护处于合理的安全水平，包括技术保护手段、管理制度控制、安全体系保障等诸多方面。
    <br />
    我们采用业界领先的技术保护措施。我们使用的技术手段包括但不限于防火墙、加密（例如SSL）、去标识化或匿名化处理、访问控制措施等。此外，我们还会不断加强安装在您设备端的软件的安全能力。例如，我们会在您的设备本地完成部分信息加密工作，以巩固安全传输；我们会了解您设备安装的应用信息和运行的进程信息，以预防病毒、木马等恶意程序。
    <br />
    我们建立了保障个人信息安全专门的管理制度、流程和组织。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，违反义务的人员会根据规定进行处罚。我们也会审查该管理制度、流程和组织，以防未经授权的人员擅自访问、使用或披露用户的信息。
    <br />
    我们建议您在使用产品和服务时充分注意对个人信息的保护，我们也会提供多种安全功能来协助您保护自己的个人信息安全。
    <br />
    3.2 安全事件处置措施
    <br />
    若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大。安全事件发生后，我们会以公告、推送通知或邮件等形式告知您安全事件的基本情况、我们即将或已经采取的处置措施和补救措施，以及我们对您的应对建议。如果难以实现逐一告知，我们将通过公告等方式发布警示。
    <br />
      第四章  我们如何使用信息
    <br />
    我们严格遵守法律法规的规定以及与用户的约定，按照本协议以及《用户注册协议》所述使用收集的信息，以向您提供更为优质的服务。
    <br />
    4.1 信息使用规则
    <br />
    我们会按照如下规则使用收集的信息：
    <br />
    1) 我们会根据我们收集的信息向您提供各项功能与服务，包括基础游戏功能、玩家互动功能、直播功能、消费功能等；
    <br />
    2) 我们会根据您使用游戏产品的频率和情况、故障信息、性能信息等分析我们产品的运行情况，以确保服务的安全性，并优化我们的产品，提高我们的服务质量。我们不会将我们存储在分析软件中的信息与您提供的个人身份信息相结合。
    <br />
    4.2 告知变动目的后征得同意的方式
    <br />
    我们将会在本指引所涵盖的用途内使用收集的信息。如我们使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次通过弹窗或邮件的方式向您告知并征得您的明示同意。
    <br />
      第五章 对外提供
    <br />
    5.1 除本指引以及《用户注册协议》规定的情形之外，我们不会主动共享、提供或转让您的个人信息至我司关联公司之外第三方，如存在其他共享、提供或转让您的个人信息或您需要我们将您的个人信息共享、提供或转让至我司关联公司之外的第三方情形时，我们会直接或间接通过该第三方征得您对上述行为的明示同意。
    <br />
    即使有前款规定，我们会在疑似未成年人消费后，尝试联系其监护人，将相关消费记录等信息告知其监护人，进行提醒、确认与处理。
    <br />
    为提升您的用户体验，我们可能需要向第三方合作伙伴等，分享已经匿名化或去标识化处理后的信息，要求其严格遵守我们关于数据隐私保护的措施与要求，包括但不限于根据数据保护协议、承诺书及相关数据处理政策进行处理，避免识别出个人身份，保障隐私安全。
    <br />
    我们不会向合作伙伴分享可用于识别您个人身份的信息（例如您的姓名或电子邮件地址），除非您明确授权。
    <br />
     
    5.2 除本指引以及《用户注册协议》另有规定外，我们不会对外公开披露所收集的个人信息。如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明示同意。
    <br />
    5.3 随着我们业务的持续发展，我们有可能进行合并、收购、资产转让等交易，我们将告知您相关情形，按照法律法规及不低于本指引所要求的标准继续保护或要求新的控制者继续保护您的个人信息。
    <br />
    5.4 根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得您的授权同意：
    <br />
    1） 与国家安全、国防安全直接相关的；
    <br />
    2） 与公共安全、公共卫生、重大公共利益直接相关的；
    <br />
    3） 与犯罪侦查、起诉、审判和判决执行等直接相关的；
    <br />
    4） 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
    <br />
    5） 个人信息主体自行向社会公众公开个人信息的；
    <br />
    6） 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
    <br />
    第六章  您的权利
    <br />
    在您使用我司提供的游戏服务期间，我们可能会视游戏产品具体情况为您提供相应的操作设置，以便您可以查询、删除、更正或撤回您的相关个人信息，您可参考相应游戏产品的具体指引进行操作。此外，我们还设置了投诉举报渠道，您的意见将会得到及时的处理。
    <br />
    1、访问您的个人信息
    <br />
    您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：“进入游戏--账号--个人信息”， 如果您无法通过上述方法访问这些个人信息，您可以随时与我们联系，或发送电子邮件至youxi@yunwente.cn我们将在15个工作日内回复您的访问请求。
    <br />
    2、更正您的个人信息
    <br />
    当您发现我们处理的关于您的个人信息有错误时，您有权要求我们作出更正。您可以通过“1、访问您的个人信息”中罗列的方式提出更正申请。如果您无法通过上述方法更正这些个人信息，您可以随时与我们联系，或发送电子邮件至youxi@yunwente.cn我们将在15个工作日内回复您的更正请求。
    <br />
    3、删除您的个人信息
    <br />
    在以下情形中，您可以向我们提出删除个人信息的请求：
    <br />
    （1）如果我们处理个人信息的行为违反法律法规；
    <br />
    （2）如果我们收集、使用您的个人信息，却未征得您的同意；
    <br />
    （3）如果我们处理个人信息的行为违反了与您的约定；
    <br />
    （4）如果您不再使用我们的产品或服务，或您注销了账号；
    <br />
    （5）如果我们不再为您提供产品或服务。
    <br />
    若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。
    <br />
    4、个人信息主体注销账户
    <br />
    您随时可注销此前注册的账户，您可以通过以下方式自行操作：”进入游戏--账号--注销账户”，如果您无法通过上述方法注销账号，您可以随时与我们联系，或发送电子邮件至youxi@yunwente.cn我们将在15个工作日内回复您的注销请求。
    <br />
    在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。
    <br />
    5、个人信息主体获取个人信息副本
    <br />
    您有权获取您的个人信息副本，您可以随时与我们联系，或发送电子邮件youxi@yunwente.cn我们将在15个工作日内回复您的请求。
    <br />
    在技术可行的前提下，如数据接口已匹配，我们还可按您的要求，直接将您的个人信息副本传输给您指定的第三方。
    <br />
    6、约束信息系统自动决策
    <br />
    在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制作出决定。如果这些决定显著影响您的合法权益，您有权要求我们作出解释，我们也将提供适当的救济方式。
    <br />
    7、响应您的上述请求
    <br />
    为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
    <br />
    我们将在十五个工作日内作出答复。如您不满意，还可以通过以下途径投诉：通过邮箱youxi@yunwente.cn联系我们。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
    <br />
    在以下情形中，我们将无法响应您的请求：
    <br />
    （1）与个人信息控制者履行法律法规规定的义务相关的；
    <br />
    （2）与国家安全、国防安全直接相关的；
    <br />
    （3）与公共安全、公共卫生、重大公共利益直接相关的；
    <br />
    （4）与刑事侦查、起诉、审判和执行判决等直接相关的；
    <br />
    （5）个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥
    <br />
    用权利的；
    <br />
    （6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但
    <br />
    又很难得到本人同意的；
    <br />
    （7）响应个人信息主体的请求将导致个人信息主体或其他个人、组织的
    <br />
    合法权益受到严重损害的；
    <br />
    （8）涉及商业秘密的。
    <br />
      第七章 变更
    <br />
    我们可能会适时对本指引进行修订。当本指引的条款发生变更时，我们会在版本更新时以适当的方式（弹窗、官网界面或邮件等方式）向您提示变更后的指引。请您仔细阅读变更后的隐私保护指引或指引内容，您继续使用我们提供的游戏产品及/或服务即表示您同意我们按照更新后的隐私保护指引收集、处理或使用您的个人信息。
    <br />
      第八章  未成年保护
    <br />
    我们高度重视未成年人个人信息的保护问题，并持续探索更新的未成年人个人信息保护方式。
    <br />
    我们会积极按照国家防沉迷政策要求，通过启用防沉迷系统保护未成年人的合法权益。我们会通过实名身份等信息校验判断相关账号的实名信息是否为未成年人，进而决定是否将此账号纳入到防沉迷体系中。另外，我们会收集您的登录时间、游戏时长等信息，通过从系统层面自动干预和限制未成年人游戏时间、启用强制下线功能等方式，引导未成年人合理游戏，并在疑似未成年人消费后尝试联系其监护人进行提醒、确认与处理，帮助未成年人健康上网。
    <br />
    另外，我们还可能会通过收集您在游戏过程中产生的游戏行为数据（如您在终端设备操作游戏时形成的游戏记录、充值记录等）来初步判断您是否是未成年人。
    <br />
    若您是未成年人的法定监护人，请您关注您所监护的未成年人是否是在取得您的授权同意之后使用游戏的服务或提供其个人信息。如果您对您所监护的未成年人的个人信息有疑问，请通过本协议约定的联系方式与我们联系。
    <br />
    特别地，若您是不满14周岁的儿童，为保护儿童个人信息，我们发布了《儿童隐私保护指引》。儿童及其监护人在使用游戏服务前，还应仔细阅读《儿童隐私保护指引》。只有在取得监护人对《儿童隐私保护指引》的同意后，您方可使用我们提供的游戏产品及服务。
    <br />
      第九章 其他
    <br />
    《儿童隐私保护指引》是适用于不满14周岁的儿童用户的个人信息保护规则。在《儿童隐私保护指引》的适用范围内，如其与《用户注册协议》、本协议存在不一致或矛盾之处，请以《儿童隐私保护指引》为准。
    <br />
      第十章 联系我们
    <br />
    我们设立了个人信息保护专职部门（或个人信息保护专员），当您有其他的投诉、建议、未成年人个人信息相关问题时，请通过邮箱youxi@yunwente.cn与我们联系。我们将尽快审核所涉问题，并在验证您的用户身份后的十五天内予以回复。
    <br />
          《第三方信息共享清单》
    <br />
    第三方SDK信息表（个人敏感信息标红显示）：
    <br />
    注意，个人信息包括：基础信息（含姓名、性别、出生年月日、住址、个人电话号码、电子邮箱等）；个人身份信息（包含身份证、军官证、护照、驾驶证等证件信息）；通讯录；个人常用设备信息（包括硬件序列号、设备MAC 地址、软件列表、唯一设备识别码（如IMEI/Android ID/IDFA/OpenUDID/GUID/SIM 卡IMSI 信息等）。以下为SDK收集的个人信息类型由所属机构提供，如有不符，请您尽快与我公司取得联系，及时修正。
    <br />
      SDK名称：阿里云实人认证SDK
    <br />
    所属机构名称：阿里云计算有限公司
    <br />
    SDK用途、功能：为用户提供实人认证服务
    <br />
    收集的个人信息类型：个人信息；个人身份信息
    <br />
    官网链接，仅供参考：https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202111292014_72878.html?spm=a2c4g.11186623.0.0.554c784346UCUh
    <br />
      SDK名称： 阿里云短信服务SDK
    <br />
    所属机构名称：  阿里巴巴云计算（北京）有限公司
    <br />
    SDK用途、功能：为用户提供短信服务
    <br />
    收集的个人信息类型：手机号
    <br />
    隐私权政策链接：https://terms.alicdn.com/legal-agreement/terms/privacy_policy_full/20230922101800634/20230922101800634.html
    <br />
    处理方式：去标识化、加密传输的安全处理方式
    <br />
      SDK名称：微信Open SDK
    <br />
    所属机构名称：深圳市腾讯计算机系统有限公司
    <br />
    SDK用途、功能：微信支付服务
    <br />
    收集的个人信息类型：设备标识信息（MAC/Android ID/IMEI/IMSI/硬件序列号）存储权限、ip地址、订单金额
    <br />
    隐私权政策链接：https://privacy.qq.com/policy/tencent-privacypolicy
    <br />
      SDK 名称：App 支付宝客户端 SDK
    <br />
    所属机构名称：支付宝(中国)网络技术有限公司
    <br />
    SDK用途、功能：支付宝支付服务
    <br />
    收集的个人信息类型：Android ID、OAID、AAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi 列表
    <br />
    隐私权政策链接：https://opendocs.alipay.com/common/02kiq3
    <br />
     
  </div>
</template>

<script setup lang="ts">
definePageMeta({ layout: 'protocol' })
</script>
